import { useRef, useState } from 'react'
import clsx from 'clsx'
import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DateAdapter from '@mui/lab/AdapterDateFns'
import DesktopDatePicker from '@mui/lab/DesktopDatePicker'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import { ReactComponent as Calendar } from '@Images/icons/calendar.svg'
import { $WhiteSmoke } from '@Styles/colors'
import './BaseDatePicker.scss'

// style section
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            overflow: 'hidden',
            transition: theme.transitions.create([
                'border-color',
                'box-shadow',
            ]),
            margin: 0,
            '& .MuiInputBase-formControl': {
                backgroundColor: `${$WhiteSmoke} !important`,
                border: `1px solid #E2E7EB`,
                borderRadius: 10,
            },
            '&:hover': {
                backgroundColor: '#fff',
            },
            '& .MuiFilledInput-input': {
                padding: '21px 12px 6px',
                fontWeight: 'bold',
                fontSize: 16,
            },
            '& .MuiFilledInput-root': {
                backgroundColor: 'unset',
            },
            '& .MuiInputBase-adornedEnd:before, .MuiInputBase-adornedEnd:after':
                {
                    display: 'none',
                },
            '& .MuiPaper-root': {
                background: 'red',
            },
            '& .MuiFilledInput-adornedEnd': {
                paddingRight: 7,
            },
            '& .Mui-disabled:hover': {
                cursor: 'not-allowed',
            },
        },
    })
)

// models section
interface IBaseDatePicker {
    label: string
    onChange?: any
    helperText?: string
    error?: any
    fullWidth?: boolean
    id?: string
    value?: string | Date
    className?: string
    inputRef?: any
    maxDate?: any
    minDate?: any
    disabled?: boolean
    readOnly?: boolean
    format?: string
    disableCloseOnSelect?: boolean
}

const BaseDatePicker = (props: IBaseDatePicker) => {
    // core section
    const {
        label = 'Label',
        onChange,
        helperText,
        error,
        value,
        className,
        inputRef,
        maxDate,
        minDate,
        disabled = false,
        readOnly = false,
        format = 'dd MMM, yyyy',
        disableCloseOnSelect = false,
    } = props
    const classes = useStyles()

    // states section
    const [isOpen, setIsOpen] = useState(false)

    // main
    return (
        <LocalizationProvider dateAdapter={DateAdapter}>
            <DesktopDatePicker
                value={value}
                onChange={onChange}
                open={isOpen}
                disabled={disabled}
                readOnly={readOnly}
                maxDate={maxDate}
                minDate={minDate}
                views={['year', 'month', 'day']}
                inputRef={inputRef}
                inputFormat={format}
                disableCloseOnSelect={disableCloseOnSelect}
                onClose={() => {
                    setIsOpen(false)
                }}
                renderInput={(params: any) => (
                    <RedditTextField
                        {...params}
                        label={label}
                        helperText={helperText}
                        className={clsx(
                            'reddit-input w-100',
                            className,
                            classes.root
                        )}
                        variant="filled"
                        error={error}
                        onClick={() => {
                            if (disabled || readOnly) return
                            setIsOpen(true)
                        }}
                        onFocus={(e) => {
                            if (isOpen) e?.target?.focus()
                        }}
                    />
                )}
                components={{ OpenPickerIcon: Calendar }}
            />
        </LocalizationProvider>
    )
}

export default BaseDatePicker
